<mat-card>
    <section style="   
    padding: 16px 16px 0;">
    <!-- <mat-card-header> -->

        <div class="row">
            <mat-card-title class="text-xl">Firma Electrónica Avanzada (FIEL)</mat-card-title>
        </div>
        <div class="row">
        <mat-card-subtitle class="text-secondary">
            <div class="row">
                <div class="col-md-10">
                    Es importante que subas tu firma electrónica.
                </div>
                <div class="col-md-2">
                    <span style="
                            font-size: 12px; font-weight: 400; color: rgb(58, 107, 197);">
                        Opcional y solo requerido para recuperar facturas.
                    </span>
                </div>

            </div>
        </mat-card-subtitle></div>
    <!-- </mat-card-header> -->
</section>
    <mat-card-content>

        <form [formGroup]="stampForm">

            <!-- Divider -->
            <mat-divider class="mt-6 mb-6"></mat-divider>

            <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">

                <!-- CER -->
                <div class="sm:col-span-2">
                    <mat-label>Sube tu archivo .CER</mat-label>
                    <app-upload-files *ngIf="!cargando" [disabled]="!cargarArchivos"
                        (uploaded)="fileBrowseHandlerCer($event)" [accept]="'.cer'">
                    </app-upload-files>

                    <ng-container *ngIf="loadCer">
                        <div class="flex items-center">
                            <mat-icon class="icon-size-5 text-primary"
                                [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                            <div class="ml-2">Archivo guardado.</div>

                        </div>
                    </ng-container>
                </div>
                <!-- KEY -->
                <div class="sm:col-span-2">
                    <mat-label>Sube tu archivo .KEY</mat-label>
                    <app-upload-files *ngIf="!cargando" [disabled]="!cargarArchivos" (uploaded)="fileBrowseHandlerKey($event)"
                        [accept]="'.key'"></app-upload-files>
                    <ng-container *ngIf="loadKey">
                        <div class="flex items-center">
                            <mat-icon class="icon-size-5 text-primary"
                                [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
                            <div class="ml-2">Archivo guardado.</div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <!-- Divider -->
            <mat-divider class="mt-6 mb-6"></mat-divider>

            <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
                <!-- Contraseña -->
                <div class="sm:col-span-2">
                    <mat-label>Contraseña de la Llave FIEL</mat-label>
                    <mat-form-field>
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:key'" matPrefix></mat-icon>
                        <input id="contrasenia" name="contrasenia" matInput type="password" formControlName="contrasenia"
                            #passwordField>
                        <button mat-icon-button type="button"
                            (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
                            matSuffix>
                            <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'password'"
                                [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                            <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'text'"
                                [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
                        </button>
                        <mat-error *ngIf="(stampForm.get('contrasenia').invalid && stampForm.get('contrasenia').touched)">
                            Campo requerido
                        </mat-error>
                        <mat-hint>Esta contraseña será la de la FIEL. En este campo no hay que definir una nueva constraseña o volver a escribir la del acceso a +Factura.</mat-hint>
                    </mat-form-field>
                </div>
                <div class="sm:col-span-1" *ngIf="files?.attributes?.cer">
                    <mat-label>&nbsp;</mat-label>
                    <button mat-button matTooltip="Descargar certificado CER"
                        (click)="downloadFile(files.attributes.cer)">
                        <mat-icon>download</mat-icon>
                        cer.
                    </button>
                </div>
                <div class="sm:col-span-1" *ngIf="files?.attributes?.key">
                    <mat-label>&nbsp;</mat-label>
                    <button mat-button matTooltip="Descargar certificado KEY"
                        (click)="downloadFile(files.attributes.key)">
                        <mat-icon>download</mat-icon>
                        key.
                    </button>
                </div>

            </div>

            <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
                <div *ngIf="noCertificado" class="col-span-2 sm:col-span-1 align-center">
                    <mat-label>Número de certificado <div>{{noCertificado}}</div></mat-label>
                </div>
                <div *ngIf="vigencia" class="col-span-2 sm:col-span-1 align-center">
                    <mat-label>Vigencia <div>{{vigencia | date: 'dd-MM-yyyy'}}</div></mat-label>
                </div>
            </div>

            <div class="grid sm:grid-cols-3 gap-6 w-full mt-8">
                <!-- Check -->
                <div class="sm:col-span-3">
                    
                    <fuse-alert [appearance]="'outline'"
                        [type]="'info'">
                        <mat-checkbox formControlName="ok" class="example-ripple-checkbox">
                            Estoy de acuerdo en que <strong>+Factura</strong> recupere, organice y ponga a mi disposición mis facturas de periodos anteriores.
                        </mat-checkbox>
                        
                    </fuse-alert>
                </div>
            </div>
            <!-- Actions -->
            <div class="flex items-center justify-end mt-5">
                <button class="ml-4" mat-flat-button type="button" [disabled]="!stampForm.valid" (click)="uploadFile()"
                    [color]="'primary'"> Guardar
                    Información
                </button>
            </div>

        </form>

    </mat-card-content>
</mat-card>